// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"3d2665bd15c0f6a5","5763":"f476aca4fe3e1232","6893":"1bd7ab4c94d0fe9f","6974":"00aba31a6fed97b7","7222":"0d80b43ba8226ecf","7937":"f55c1c1098663b25"}[chunkId] + ".js";
};